/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackageStatusDto } from '../../models/work-package-status-dto';

export interface GetWorkPackageStatus$Params {
  id: string;
}

export function getWorkPackageStatus(http: HttpClient, rootUrl: string, params: GetWorkPackageStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageStatusDto>> {
  const rb = new RequestBuilder(rootUrl, getWorkPackageStatus.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageStatusDto>;
    })
  );
}

getWorkPackageStatus.PATH = '/v0/workPackageStatuses/{id}';
